import { ToastContentProps } from 'react-toastify';
import { ButtonIcon } from 'src/general/components/Button/ButtonIcon';

export const CarComparisonDismissSnackbarButton = ({ closeToast }: Pick<ToastContentProps, 'closeToast'>) => (
  <ButtonIcon
    iconName="circle-cross-filled"
    title="Dismiss"
    onClick={closeToast}
    variant="tertiary"
    size="xsmall"
    styling="round"
  />
);
